const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay } = window.BAO.Carousel.plugins

class LogoCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  setupCarousel () {
    if (this.els?.slides?.exists !== true) {
      return null
    }

    const loop = this.getAttribute('data-loop') === 'true'
    const autoplay = this.getAttribute('data-autoplay') === 'true'
    const autoplaySpeed = Number(this.getAttribute('data-autoplay-speed') || 3)

    const plugins = [setInitialised()]

    if (autoplay === true) {
      plugins.push(
        useAutoplay(autoplaySpeed, {
          pauseOnHover: true,
        }),
      )
    }

    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1200,
        },
        loop,
        mode: 'snap',
        rubberband: false,
        dragStartThreshold: 10,
        drag: true,
        slides: {
          perView: 2.5,
          spacing: 24,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 5,
              spacing: 40,
            },
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 6,
              spacing: 48,
            },
          },
        },
      },
      plugins,
    )

    this.els?.wrapper?.element?.setAttribute('data-initialised', 'true')

    return slider
  }
}

if (!customElements.get('logo-carousel')) {
  customElements.define('logo-carousel', LogoCarousel)
}
